<template>
  <div>
        <div class="layui-card" style="min-height:500px">
            <div class="layui-card-body">
                <div class="layui-form  layui-form-pane" lay-filter="example">
                    <p class="titleProject">项目基本信息</p>
                    <table class="layui-table" style="width: 100%;">
                        <colgroup>
                            <col width="150">
                            <col width="200">
                            <col>
                        </colgroup>
                        <tbody>
                            <tr>
                                <td class="JBtitle">项目编号:</td>
                                <td class="JBvalue" id="PrjNo">
                                    {{bulletinList.PrjNo}}
                                    </td>
                                <td class="JBtitle">项目名称:</td>
                                <td class="JBvalue" id="PrjName">
                                    {{bulletinList.PrjName}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">采购单位:</td>
                                <td class="JBvalue" id="YzCompanyName">
                                    {{bulletinList.yzCompanyName}}
                                    </td>
                                <td class="JBtitle">报价方式:</td>
                                <td class="JBvalue">
                                    {{bulletinList.QuoteType}}
                                </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">经办人:</td>
                                <td class="JBvalue" id="YzCompanyLinkMan">
                                    {{bulletinList.YzCompanyLinkMan}}
                                    </td>
                                <td class="JBtitle">联系电话:</td>
                                <td class="JBvalue" id="YzCompanyLinkPhone">
                                    {{bulletinList.yzCompanyLinkPhone}}
                                    </td>
                            </tr>
                            <tr v-if="bulletinList.AgentCompanyLinkMan!=''">
                                <td class="JBtitle">代理联系人:</td>
                                <td class="JBvalue" id="YzCompanyLinkMan">
                                    {{bulletinList.AgentCompanyLinkMan}}
                                    </td>
                                <td class="JBtitle">代理联系人电话:</td>
                                <td class="JBvalue" id="YzCompanyLinkPhone">
                                    {{bulletinList.AgentCompanyLinkMb}}/{{bulletinList.AgentCompanyLinkPhone}}
                                    </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">成交发布时间:</td>
                                <td class="JBvalue" id="BookSellMoney">
                                    {{bulletinList.CloseDate.slice(0,10)}}
                                </td>
                                <td v-if="bulletinList.BulletinEndTime&&bulletinList.BulletinEndTime.length>0" class="JBtitle">公告结束时间:</td>
                                <td v-if="bulletinList.BulletinEndTime&&bulletinList.BulletinEndTime.length>0" class="JBvalue" id="BookSellMoney">
                                    {{bulletinList.BulletinEndTime}}
                                </td>
                            </tr>
                            <tr>
                                <td class="JBtitle">开标备注:</td>
                                <td class="JBvalue" id="Remark" colspan=3>
                                    {{bulletinList.CloseRemark}}
                                    </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="margin-top:25px" class="layui-from" id="CusTable">
                    <a-table style="width: 100%" bordered :columns="columns" :data-source="bulletinList.ZbInfoList" :rowKey="record=>record.Name" :pagination="false">
                        <template slot="BasePrice" slot-scope="text">
                            <span>{{text}}元</span>
                        </template>
                        <template slot="FinallyPrice" slot-scope="text">
                            <span>{{text}}{{bulletinList.QuoteTypeTXT}}</span>
                        </template>
                    </a-table>
                </div>
                <div class="layui-from" style="text-align:center;margin-top:25px">
                    <button id="wjs" v-if="bulletinList.isInvite!='1'" class="layui-btn layui-btn-normal" @click="baojia()">查看采购公告</button>
                    <button id="wjs" v-if="this.GZGGList.length>0&&bulletinList.isInvite!='1'" style="margin-left:15px" class="layui-btn layui-btn-normal" @click="view()">查看更正公告</button>
                </div>
            </div>
        </div>
        <a-modal
        title="查看更正公告   "
        :visible="visible"
        :width="1200"
        :maskClosable="false"
        @cancel="handleCancel"
        cancelText="关闭"
        >
             <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
            </template>
            <div>
                <a-table style="width: 100%" bordered :columns="GZcolumns" :data-source="GZGGList" :rowKey="record=>record.AutoId" :pagination="false">
                    <template slot="AutoId" slot-scope="text">
                            <a v-on:click="viewArticle(text)">查看</a>
                        </template>
                </a-table>
                <div style="margin-top: 25px;text-align: center;"><h1>{{Vtitle}}</h1></div>
                <div style="margin: 15px 60px;" v-html="htmlText"></div>
            </div>
        </a-modal>
    </div>
</template>
<script>
const columns = [
  {
    title: "标段名称",
    dataIndex:'SectName',
    width: 210,
  },
  
  {
    title: '成交人',
    dataIndex: 'CustomerName',
    width: 190,
  },
  {
    title: '预算',
    dataIndex: 'BasePrice',
    width: 80,
    scopedSlots: { customRender: 'BasePrice' },
  },
  {
    title: '成交报价',
    dataIndex: 'FinallyPrice',
    width: 80,
    scopedSlots: { customRender: 'FinallyPrice' },
  }
];
const GZcolumns = [
    {
      title: '公告标题',
      dataIndex: 'BulletinTitle',
      width: 300,
    },
    {
      title: '操作',
      dataIndex: 'AutoId',
      width: 10,
      scopedSlots: { customRender: 'AutoId' },
    }
]
export default {
  name: "bulletin-text",
  props: {
    TextList: {
      type: Object,
      default() {
        return {
          prjId: '',
        };
      },
    },
  },
  data() {
    return {
        columns,
        GZcolumns,
        bulletinList:{},
        GZGGList:{},
        visible:false,
        htmlText:'',
        Vtitle:'',
    };
  },
  created() {
      this.$http.get('https://ygcg.nbcqjy.org:8075/api/Notoken/GetOnlineInquireZbBulletin?PrjId='+this.TextList.prjId).then((res) => {
            this.bulletinList = res.data.Body.Data;
            if(this.bulletinList.QuoteType=='下浮率'){
                this.columns = [
                    {
                        title: "标段名称",
                        dataIndex:'SectName',
                        width: 210,
                    },
                    
                    {
                        title: '成交人',
                        dataIndex: 'CustomerName',
                        width: 190,
                    },
                    {
                        title: '成交报价(下浮率)',
                        dataIndex: 'FinallyPrice',
                        width: 80,
                        scopedSlots: { customRender: 'FinallyPrice' },
                    }
                ];
            }
            this.GZGGList = res.data.Body.Data.CorrectionNotices;
            if(this.GZGGList.length>0){
                this.htmlText = this.GZGGList[0].BulletinContent
                this.Vtitle = this.GZGGList[0].BulletinTitle
            }
      })
  },
  methods: {
      baojia(){
        window.open("http://ygcg.nbcqjy.org/detail?type=1&prjId=" + this.TextList.prjId);
      },
      view(){
        // window.open("http://ygcg.nbcqjy.org/GZdetail?type=1&prjId=" + this.TextList.prjId);
        this.visible = true
      },
      handleCancel() {
        this.visible = false
      },
      viewArticle(id){
        // alert(id)
        this.GZGGList.forEach(item => {
            if(item.AutoId==id){
                this.htmlText = item.BulletinContent
                this.Vtitle = item.BulletinTitle
            }
        });
      }
  },
};
</script>
<style lang="less">
        body {
            padding-top: 0px !important;
        }

        .dtree-theme-item-this {
            background-color: transparent !important;
        }

        .JBtitle {
            background-color: #FBFBFB;
            width: 17%;
            text-align: center;
        }

        .JBvalue {
            width: 33%;
        }

        /*       .layui-input,
        .layui-textarea {
            border-width: 0px;
        }*/

        textarea {
            resize: none;
        }

        .layui-form-label {
            width: 16% !important;
        }

        .layui-input-inline {
            width: 30% !important;
        }

        .layui-input-block {
            margin-left: 230px !important;
        }

        #Remark {
            width: 80% !important;
            line-height: 36px;
            min-height: 38px;
            border: 1px solid #e6e6e6;
            box-sizing: border-box;
        }

        .layui-table-cell {
            height: auto;
            overflow: visible;
            text-overflow: inherit;
            white-space: normal;
        }
        .titleProject {
            color: #222;
            margin: 0;
            font-size: 16px;
            padding: 16px 24px 6px 24px;
            font-weight: bold;
        }

        #ProjectEdit .layui-form-label {
            width: 32%;
        }

        #ProjectEdit .layui-form-item .layui-input-inline {
            width: 40%;
        }


        /* 修改layui */
        .layui-form-item .layui-inline{
            margin-bottom: 0px;
        }
        .layui-form-item .layui-form-checkbox[lay-skin=primary]{
            margin-top: 0;
        }
        td{
            padding: 9px 15px!important;
        }
        .layui-btn {
            display: inline-block;
            height: 38px;
            line-height: 38px;
            padding: 0 18px;
            background-color: #1E9FFF;
            color: #fff;
            white-space: nowrap;
            text-align: center;
            font-size: 14px;
            border: none;
            border-radius: 2px;
            cursor: pointer;
        }
        table td, table th {
            border-bottom: 1px solid #e6e6e6!important;
            border-right: 1px solid #e6e6e6!important;
        }
        table {
            border-top: 1px solid #e6e6e6!important;
            border-left: 1px solid #e6e6e6!important;
        }
        #CusTable .ant-table-thead > tr > th {
            padding: 8px 16px;
        }
</style>